
import React from 'react';
import { DashboardContainer, Spinner } from "../../funcs/utils";
import {sprintf} from "sprintf-js";
import { INVEST_FOR } from "../../../lib/onboarding-tda/shared-prms";
import { xfer_firm_name } from "../../../lib/onboarding-tda/TDA_holding_firm_menu";
import { DTC_ID_TO_LABEL } from "../../../lib/onboarding-tda/TDA_dtc_clearing_members_menu";

const parse_date = timestamp_ms => {
  const date = new Date(timestamp_ms);
  return sprintf("%04d-%02d-%02d %02d:%02d:%02d",
    date.getFullYear(), date.getMonth() + 1, date.getDate(),
    date.getHours(), date.getMinutes(), date.getSeconds());
}

const SpouseInvestmentLabel = {
  COMMUNITY_PROPERTY: "Married Community Property",
  TENANTS_BY_ENTIRETY: "Tenants by Entirety\n",
  JTWROS: "Joint Tenants With Rights Of Survivorship",
  TENANTS_IN_COMMON: "Tenants in Common",
}

const FilingStatusLabel = {
  single: "Single",
  married_joint: "Married Filing Jointly",
  married_separate: "Married Filing Separately",
}

/*const XferIraLabel = {
  traditional_ira: "Transfer an IRA from another firm",
  rollover_ira: "Rollover a 401k into a Rollover IRA",
  roth_ira: "Transfer a Roth IRA",
  sepp_ira: "Transfer a SEPP IRA",
  simple_ira: "Transfer a SIMPLE IRA",
}*/

const dump_title = title => {
  return (
    <div align={"center"} style={{fontSize: "1.5rem", margin: "1rem"}}>
      {title}
    </div>)
}

const create_joint = onboarding => {
  const acct_type = onboarding.joint_acct_type[0].split("|")[1];
  let co_pct;

  if (acct_type === "TENANTS_IN_COMMON") {
    co_pct = (
      <div>
        {onboarding.tenant_owner_pct}% Owner - {onboarding.tenant_co_owner_pct}% Co-owner
      </div>
    );
  }

  return (
    <div style={{marginLeft: "2rem"}}>
      <div>Joint - State: {onboarding.joint_acct_state}</div>
      <div>{SpouseInvestmentLabel[acct_type]}</div>
      { co_pct }
    </div>
  );
}

const create_ira = onboarding => {
  let result;
  const ira_type = onboarding.ira_type[0].split("|")[1];
  if (ira_type === "traditional") {
    result = (
      <div style={{marginLeft: "2rem"}}>Traditional IRA</div>
    )
  } else if (ira_type === "roth") {
    const filing_status = onboarding.filing_status[0].split("|")[1];
    result = (
      <div style={{marginLeft: "2rem"}}>
        Roth IRA - {FilingStatusLabel[filing_status]}
      </div>
    )
  }
  return result;
}

const create_trust = onboarding => {
  const state = onboarding.ugma_state_menu_2;
  const age = onboarding.child_age_menu;
  return (
    <div style={{marginLeft: "2rem"}}>
      State: {state} Age: {age}
    </div>
  )
}

const dump_bank_statements = onboarding => {
  if (!onboarding.bank_statements || onboarding.bank_statements.length === 0) {
    return null;
  }
  return (
    <div>
      { onboarding.bank_statements.map(item => {
        return (<div>Bank Statement: {item.name}</div>);
      })}
    </div>
  )
}

const dump_xfer_acct = onboarding => {
  const acct_type = onboarding.xfer_acct_type[0].split("|")[1];
  let result;

  if (acct_type === "individual") {
    result = (<div>Transfer Account Type: Individual</div>);
  } else if (acct_type === "joint_spouse") {
    // Spouse as Community Property
    result = (<div>Transfer Account Type: Spouse as Community Property</div>)
  } else if (acct_type === "joint_tenants") {
    // Joint Tenants with Rights of Survivorship
    result = (<div>Transfer Account Type: Joint Tenants with Rights of Survivorship</div>)
  } else if (acct_type === "tenants_common") {
    // Tenants in Common
    result = (
      <div>
        <div>Transfer Account Type: Tenants in Common</div>
        <div>{onboarding.xfer_tenant_owner_pct}% Owner - {onboarding.xfer_tenant_co_owner_pct}% Co-Owner</div>
      </div>
    );
  } else if (acct_type === "ira_rollover") {
    result = (
      <div>
        <div>Transfer Account Type: IRA</div>
      </div>
    )
  } else if (acct_type === "trust") {

  }
  return result;
}

const parse_role = (onboarding, index) => {
  const prms = [
    "first_name", "last_name", "ss", "phone_number",
    "dob", "email", "city", "state", "street", "zip"
    ];
  const result = {};
  for(let i=0; i < prms.length; i++) {
    const prop = sprintf("role_%d_%s", index, prms[i]);
    if (!onboarding[prop]) {
      return null;
    }
    result[prms[i]] = onboarding[prop];
  }
  return result;
}

const dump_role = role => {
  return (
    <div>
      <div>Name: {role.first_name} {role.last_name}</div>
      <div>SS: {role.ss}</div>
      <div>Phone: {role.phone_number}</div>
      <div>Email: {role.email}</div>
      <div>DOB: {role.dob}</div>
      <div>Addr: {role.street}</div>
      <div>Addr: {role.city} {role.state}, {role.zip}</div>
    </div>
  )

}

class OnboardingSummary extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      wlf_id: this.props.wlf_id,
      username: this.props.username,
      acct_index: this.props.acct_index,
      loading: false,
    };
  }

  componentDidMount = () => {
    this.maybeLoadOnboarding()
  };

  getOnboardingData = () => {
    const username = this.props.username;
    const index_key = sprintf("%04d", this.props.acct_index);
    return this.props.onboarding
      && this.props.onboarding[username]
      && this.props.onboarding[username][index_key];
  }

  maybeLoadOnboarding = () => {
    if (!this.getOnboardingData()) {
      this.props.loadOnboardingData(this.props.acct_index, this.props.username);
    }
  }

  maybeWelcome = onboarding => {
    if (!onboarding.invest_for) {
      return null;
    }
    /*const title_style = {
      fontSize: "1.5rem",
    }*/
    let invest_type;

    const invest_for = INVEST_FOR.getAppButtons(onboarding)[0];
    const invest_for_id = invest_for.id.split("|")[1];
    if (invest_for_id === "standard_invest_0") {
      if (onboarding.invest_type === "individual") {
        invest_type = (
          <div style={{marginLeft: "2rem"}}>
            Individual
          </div>
        )
      } else if (onboarding.invest_type === "spouse") {
        invest_type = create_joint(onboarding);
      }
    } else if (invest_for_id === "IRA") {
      invest_type = create_ira(onboarding);
    } else if (invest_for_id === "trust") {
      invest_type = create_trust(onboarding);
    }

    return (<div style={{marginTop: "1rem"}}>
      { dump_title("Welcome") }
      <div>{invest_for.label}</div>
      { invest_type }
    </div>)
  }

  maybePersonalInfo = onboarding => {
    const role_0 = parse_role(onboarding, 0);
    const role_1 = parse_role(onboarding, 1);
    const title_style = {
      fontSize: "1.5rem",
      margin: "1rem",
    }
    if (!role_0) {
      return null;
    }

    if (role_0 && role_1) {
      return (
        <div>
          { dump_title("Personal Info") }
          <div style={{display: "flex"}}>
            <div style={{flex: "1"}}>
              { dump_role(role_0) }
            </div>
            <div style={{flex: "1"}}>
              { dump_role(role_1)}
            </div>
          </div>
        </div>

      )
    } else {
      return (
        <div>
          <div style={title_style} align={"center"}>Personal Info</div>
          { dump_role(role_0) }
        </div>
      )
    }
  }

  maybeTransfer = onboarding => {
    if (!onboarding.acct_title) {
      return null;
    }

    let dtc_firm;
    if (onboarding.xfer_firm_name === "other") {
      dtc_firm = (
        <div>
          DTC Clearing: {DTC_ID_TO_LABEL(onboarding.dtc_firm_menu)}
        </div>
      )
    }
    return (
      <div>
        { dump_title("Transfer") }
        <div style={{display: "flex"}}>
          <div style={{flex: "1"}}>
            <div>
              Account Name: {onboarding.acct_title}
            </div>
          </div>
          <div style={{flex: "1"}}>
            <div>
              Account Number: {onboarding.acct_number}
            </div>
          </div>
        </div>
        <div>
          Delivering Firm: { xfer_firm_name.getAppLabel(onboarding)}
        </div>
        { dtc_firm }
        <div style={{display: "flex"}}>
          <div style={{flex: "1"}}>
            <div>Address: {onboarding.firm_address_0}</div>
            <div>Address: {onboarding.firm_address_1}</div>
          </div>
          <div style={{flex: "1"}}>
            <div>Phone: {onboarding.firm_phone}</div>
          </div>
        </div>
        { dump_bank_statements(onboarding) }
        { dump_xfer_acct(onboarding) }
      </div>
    )
  }

  maybeRenderOnboarding = () => {
    const title_style = {
      fontSize: "1.5rem",
      fontWeight: "bold",
    }
    const onboarding = this.getOnboardingData();
    if (!onboarding) {
      return null;
    }

    const date_str = parse_date(onboarding.last_timestamp);

    return (
      <div>
        <div style={title_style} align={"center"}>
          Onboarding - {onboarding.tda_account_number}
        </div>
        <div>{onboarding.role_0_first_name} {onboarding.role_0_last_name} - {onboarding.role_0_email}</div>
        <div>Timestamp: {date_str}</div>
        { this.maybeWelcome(onboarding) }
        { this.maybePersonalInfo(onboarding) }
        { this.maybeTransfer(onboarding) }
      </div>
    )
  }

  render = () => {

    const is_loading = this.props.onboarding.loading;

    const loading_html = is_loading
      ? (
        <div align={"center"}>
          <Spinner size={"2rem"}/>
        </div>
      ) : null;

    return (
      <div className='img-col'>
        <DashboardContainer>
          { loading_html }
          { this.maybeRenderOnboarding() }
        </DashboardContainer>
      </div>
    );
  }
}

export { OnboardingSummary };
